<template>
    <section id="QA">
        <h2 class="title mt-50 mb-40">常見問題</h2>
        <div class="container">
            <div class="QFrame" v-for="item in qaData" @click="qaToggle(item)" :key="item.id">
                <div class="Question">
                    {{ item.question }}
                    <transition name="fade">
                        <div class="answer" v-if="item.qaShow == true">
                            <div v-html="item.answer"></div>
                        </div>
                    </transition>
                </div>
                <div class="QBtn">
                    <img src="../assets/arrow.svg" :class="{ rotate: item.qaShow }" />
                </div>
            </div>
        </div>
    </section>
</template>
<script setup>
import {reactive} from "vue";

const qaData = reactive([
     {
        id: 0,
        question: "抽獎資格可以累計嗎？",
        answer: `<p>於活動期間內，只要符合各項活動條件並完成投保，每張符合資格之保單皆可獲得對應抽獎機會。各獎項之抽獎資格獨立計算，符合條件的保單越多，可累積的抽獎機會也越多。</p>`,
        qaShow: false,
    },
    {
        id: 1,
        question: "雙週抽 iPhone Duo抽獎次數怎麼算？",
        answer: `<p>每張符合活動資格之車體險保單，每週可獲得 1次抽獎機會；若以純電動汽車投保符合資格之車體險，每週可額外獲得 1 次抽獎機會。若於第一週取得資格且未中獎，可參與 6 週雙週抽及季末加碼抽獎，因此純電動汽車保單最高可累積 14次抽獎機會（6週×2次＋季末加碼2次）；一般車體險保單最高可累積 7次抽獎機會（6週 × 1次＋季末加碼1次）。</p>`,
        qaShow: false,
    },
    {
        id:2,
        question: "我抽中了車體險加碼獎-iPhone Duo 贈品何時寄送?",
        answer: `<p>iPhone Duo 獎項採統一作業方式寄送。中獎名單將於各週抽獎後陸續公告，中獎者完成領獎程序後，主辦單位將另行通知寄送事宜，實際寄送時間以主辦單位通知為準。</p>`,
        qaShow: false,
    }
    ,
    {
        id:3,
        question: "投保機車強制責任保險二年期並選擇電子保單，可以參加立即抽嗎？",
        answer: `<p>可以，若前一期強制險保單非投保新安東京海上產險，完成投保後可獲得立即抽抽獎機會乙次。另如投保機車強制責任保險二年期並選擇電子保單，還可額外獲得抽獎機會乙次，該獎項將由主辦單位於活動結束後統一抽出。</p>`,
        qaShow: false,
    },
    {
        id:4,
        question: "我有投保完成，為何無法進行立即抽？",
        answer: "因您的保單需經網路投保審核流程，確認審核及付款成功後才可參加抽獎活動，審核期約２個工作天，您可於2個工作天後再次登入活動頁面。若3個工作天後仍查不到，請E-mail至網路投保活動小組詢問。</p><p> < E-mail：<a href='mailto:rex.chen@tmnewa.com.tw'>rex.chen@tmnewa.com.tw</a> ></p>" +
            "<p class='red'>＊請注意：抽獎活動僅限會員參加，且要保人身分證字號需與會員註冊時填寫的資料相符，抽獎機會才會匯入會員帳戶中。</p>",
        qaShow: false,
    }
    ,
    {
        id:5,
        question: "我已經先在新安東京海上產物保險網路投保成功後才發現有這個活動，請問這張保單能得到抽獎機會嗎？",
        answer: `<p>只要您的網路投保日期是於本活動期間內(2026年07月01日00：00至2026年12月31日23：59)，且網路投保的保險商品內容與本次活動說明指定保險商品相同，則可在本活動註冊(登入)後查到您所獲得的【大獎】、【電子保單獎】、【立即抽】抽獎機會，若對查詢結果有任何疑問，請E-mail至網路投保活動小組詢問。</p>
        <p>< E-mail：<a href='mailto:rex.chen@tmnewa.com.tw'>rex.chen@tmnewa.com.tw</a> ></p>`,
        qaShow: false,
    }
    ,
    {
        id:6,
        question: "如果投保後進行保單異動(含批改、過戶、變更要保人或被保險人等)，仍然保有抽獎資格嗎？",
        answer: "很抱歉，如果所抽出的得獎者經查明該中獎的保單已退保、過戶、變更要保人，則失去得獎資格，即使事後再重覆投保也無法獲得該獎項，得獎者視為放棄活動資格。",
        qaShow: false,
    }
    ,
    {
        id:7,
        question: "如果在「立即抽」抽中獎項，獎品會馬上寄給我嗎?",
        answer: "【立即抽】獎項為電子禮券，您可於中獎後於網頁上透過連結獲得獎項。",
        qaShow: false,
    }
    ,
    {
        id:8,
        question: "請問我過去有參與過網路投保相關活動，本次活動還需要再註冊一次嗎？",
        answer: "為提供完善的客戶服務，抽獎活動將與會員資料統一，未曾註冊網路投保會員請重新註冊即可登入抽獎活動，已註冊網路投保會員可直接於活動網頁進行登入。",
        qaShow: false,
    }
    ,
    {
        id:9,
        question: "我在2026年1月~6月期間完成投保且符合抽獎資格，可否繼續參加2026年月07月~12月的「網路投保-好禮三重抽」的抽獎活動？",
        answer: "您可以於活動頁登入後繼續參與【立即抽】抽獎活動，但【車體險加碼獎】、【大獎】及【電子保單獎】、【機車強制險加碼獎】抽獎資格以投保日當時抽獎資格為限。",
        qaShow: false,
    }
    ,
     {
        id:10,
        question: "若我選擇旅平險多人投保，同一保單內的所有被保險人都會獲得抽獎機會嗎？",
        answer: "不會。本活動各項抽獎機會均以「實際成立保單數」為計算基準，並以要保人的會員帳號作為抽獎資格認定依據。同一張保單即使包含多位被保險人，仍僅計算為一張保單，獲得一次抽獎機會，不因被保險人人數增加而增加抽獎次數。",
        qaShow: false,
    }
])
const qaToggle = (item) => {
    item.qaShow = !item.qaShow;
};
</script>
<style lang="scss">
#QA {
    padding-bottom: 120px;
    @media screen and (max-width: $pc) {
        background-image: none;
        padding-bottom: 50px;
    }
    .container{
        display: flex;
        flex-direction: column;
        gap: 20px;
    }
    .QFrame {
        background-color: $white;
        background-image: url("../assets/Q.svg");
        background-repeat: no-repeat;
        background-position: left 20px top 25px;
        padding: 20px;
        border: 2px solid $black;
        border-radius: 20px;
        width: 100%;
        box-sizing: border-box;
        line-height: 35px;
        font-size: 16px;
        .Question {
            width: 93%;
            display: inline-block;
            margin-left: 4%;
            font-weight:bold;
            @media screen and (max-width: $mobile-small) {
                margin: 0 2% 0 10%;
                width: 80%;
                line-height:24px;
                font-size: 16px;
            }
        }
        .QBtn {
            display: inline-block;
            width: 3%;
            vertical-align: top;
            text-align: right;
            @media screen and (max-width: $mobile-small) {
                width:5%;
            }
            img {
                display: inline-block;
                margin: 0 auto;
                &.rotate {
                    transform: rotateX(-180deg);
                }
            }
        }
        .answer {
            border-top: 1px dashed #ccc;
            padding-top:10px;
            margin-top:10px;
            line-height:25px;
            font-weight:400;
        }
    }
}
</style>
